export const AppRouteNames = {
  // Home
  home: {
    label: "ホーム",
    value: "home",
  },

  // Login
  login: {
    label: "ログイン",
    value: "login",
  },
  logout: {
    label: "ログアウト",
    value: "logout",
  },
  recover: {
    label: "新規登録",
    value: "recover",
  },
  resetPassword: {
    label: "パスワード再設定",
    value: "reset_password",
  },
  register: {
    label: "新規登録",
    value: "register",
  },

  // Login
  companyLogin: {
    label: "ログイン",
    value: "company_login",
  },
  companyLogout: {
    label: "ログアウト",
    value: "company_logout",
  },
  companyRecover: {
    label: "新規登録",
    value: "company_recover",
  },
  companyResetPassword: {
    label: "パスワード再発行",
    value: "company_reset_password",
  },
  companyRegister: {
    label: "新規登録",
    value: "company_register",
  },

  // Information
  information: {
    label: "お知らせ一覧",
    value: "information",
  },
  informationDetail: {
    label: "お知らせの詳細",
    value: "information_detail",
  },

  // Renew visa
  renewVisa: {
    label: "在留期間更新一覧",
    value: "renew_visa",
  },

  renewVisaPresent: {
    label: "在留期間更新（今回）",
    value: "renew_visa_present",
  },
  renewVisaPresentEmployeeApplication: {
    label: "在留期間更新の外国人情報（今回）",
    value: "renew_visa_present_employee_application",
  },
  renewVisaPresentCompanyApplication: {
    label: "在留期間更新の企業情報（今回）",
    value: "renew_visa_present_company_application",
  },
  renewVisaPresentUploadApplication: {
    label: "在留期間更新の添付書類（今回）",
    value: "renew_visa_present_upload_application",
  },
  renewVisaInfoHistory: {
    label: "在留期間更新一覧（過去）",
    value: "renew_visa_info_history",
  },
  renewVisaInfoHistoryDetail: {
    label: "在留期間更新（過去）",
    value: "renew_visa_info_history_detail",
  },
  renewVisaInfoHistoryCompanyApplication: {
    label: "在留期間更新の企業情報（過去）",
    value: "renew_visa_info_history_company_application",
  },
  renewVisaInfoHistoryEmployeeApplication: {
    label: "在留期間更新の外国人情報（過去）",
    value: "renew_visa_info_history_employee_application",
  },
  renewVisaInfoHistoryUploadApplication: {
    label: "在留期間更新の添付書類（過去）",
    value: "renew_visa_info_history_upload_application",
  },
  renewVisaPresentRequestOnlineUploadApplication: {
    label: "在留期間更新の所属機関等に書類準備やレビューの依頼（今回）",
    value: "renew_visa_present_request_online_upload_application",
  },
  renewVisaHistoryRequestOnlineUploadApplication: {
    label: "在留期間更新の所属機関等に書類準備やレビューの依頼（過去）",
    value: "renew_visa_history_request_online_upload_application",
  },

  // Certificate of Eligibility (COE) Section
  coe: {
    label: "認定・変更申請の一覧",
    value: "coe",
  },
  coePresent: {
    label: "認定・変更申請（今回）",
    value: "coe_present",
  },

  coePresentEmployeeApplication: {
    label: "認定・変更申請の外国人情報（今回）",
    value: "coe_present_employee_application",
  },

  coePresentCompanyApplication: {
    label: "認定・変更申請の企業情報（今回）",
    value: "coe_present_company_application",
  },

  coePresentUploadEmployeeApplication: {
    label: "認定・変更申請の外国人ごとの添付書類（今回）",
    value: "coe_present_upload_employee_application",
  },

  coeHistoryUploadEmployeeApplication: {
    label: "認定・変更申請の外国人ごとの添付書類（過去）",
    value: "coe_history_upload_employee_application",
  },

  coePresentUploadCompanyApplication: {
    label: "認定・変更申請の所属機関共通添付書類（今回）",
    value: "coe_present_upload_company_application",
  },

  coeHistoryUploadCompanyApplication: {
    label: "認定・変更申請の所属機関共通添付書類（過去）",
    value: "coe_history_upload_company_application",
  },

  coeInfoHistory: {
    label: "認定・変更申請一覧（過去）",
    value: "coe_info_history",
  },

  coeInfoHistoryDetail: {
    label: "認定・変更申請（過去）",
    value: "coe_info_history_detail",
  },

  coeInfoHistoryCompanyApplication: {
    label: "認定・変更申請の企業情報（過去）",
    value: "coe_info_history_company_application",
  },

  coeInfoHistoryEmployeeApplication: {
    label: "認定・変更申請の外国人情報（過去）",
    value: "coe_info_history_employee_application",
  },

  coePresentRequestOnlineUploadApplication: {
    label: "認定・変更申請の所属機関等に書類準備やレビューの依頼（今回）",
    value: "coe_present_request_online_upload_application",
  },

  coeHistoryRequestOnlineUploadApplication: {
    label: "認定・変更申請の所属機関等に書類準備やレビューの依頼（過去）",
    value: "coe_history_request_online_upload_application",
  },

  // Employment Conditions and Support Plan Documents
  conditionAndSupportPlanDocument: {
    label: "雇用条件書・支援計画書の所属機関一覧",
    value: "condition_and_support_plan_documents",
  },

  conditionAndSupportPlanDocumentCondition: {
    label: "雇用条件書・賃金の支払",
    value: "condition_and_support_plan_documents_condition",
  },

  conditionAndSupportPlanDocumentSupportPlan: {
    label: "支援計画書",
    value: "condition_and_support_plan_documents_support_plan",
  },

  conditionAndSupportPlanDocumentConditionContract: {
    label: "雇用条件書作成",
    value: "condition_and_support_plan_documents_condition_contract",
  },

  conditionAndSupportPlanDocumentConditionWage: {
    label: "賃金の支払作成",
    value: "condition_and_support_plan_documents_condition_wage",
  },

  conditionAndSupportPlanDocumentSupportPlanBasic: {
    label: "支援計画書の基本事項",
    value: "condition_and_support_plan_documents_support_plan_basic",
  },

  conditionAndSupportPlanDocumentSupportPlanDetailOne: {
    label: "支援計画書の支援内容1～4",
    value: "condition_and_support_plan_documents_support_plan_detail_one",
  },

  conditionAndSupportPlanDocumentSupportPlanDetailTwo: {
    label: "支援計画書の支援内容5～9",
    value: "condition_and_support_plan_documents_support_plan_detail_two",
  },

  conditionAndSupportPlanDocumentSupportPlanCoexistencePolicy: {
    label: "支援計画書の共生施策関係",
    value: "condition_and_support_plan_documents_support_plan_coexistence_policy",
  },
  // Contact
  contact: {
    label: "お問い合わせ",
    value: "contact",
  },

  // Employee
  employeeList: {
    label: "特定技能外国人情報",
    value: "employee_list",
  },
  employeeCreate: {
    label: "特定技能外国人の新規外国人登録",
    value: "employee_create",
  },
  employeeDetail: {
    label: "特定技能外国人の詳細画面",
    value: "employee_detail",
  },
  employeeUploadAvatar: {
    label: "特定技能外国人情報の写真のアップロード？",
    value: "employee_upload_avatar",
  },
  employeeEdit: {
    label: "特定技能外国人情報の編集",
    value: "employee_edit",
  },

  // about
  companyList: {
    label: "所属機関の一覧",
    value: "company_list",
  },
  companyCreate: {
    label: "新規所属機関作成",
    value: "company_create",
  },
  companyDetail: {
    label: "会社情報",
    value: "company_detail",
  },
  companyEdit: {
    label: "所属機関の編集画面",
    value: "company_edit",
  },
  companyBranch: {
    label: "事業所一覧",
    value: "company_branch",
  },
  companyBranchCreate: {
    label: "新規事業所登録",
    value: "company_branch_create",
  },
  companyBranchEdit: {
    label: "事業所の編集",
    value: "company_branch_edit",
  },
  companyAccount: {
    label: "オンライン申請のアカウント管理",
    value: "company_account",
  },
  companyAccountEdit: {
    label: "オンライン申請のアカウント管理の編集画面",
    value: "company_account_edit",
  },

  // company self
  companySelf: {
    label: "会社情報",
    value: "company_self",
  },
  companySelfEdit: {
    label: "会社情報の編集画面",
    value: "company_self_edit",
  },
  companySelfBranch: {
    label: "事業所管理",
    value: "company_self_branch",
  },
  companySelfBranchCreate: {
    label: "事業所管理の作成",
    value: "company_self_branch_create",
  },
  companySelfBranchEdit: {
    label: "事業所管理の編集",
    value: "company_self_branch_edit",
  },
  companySelfAccount: {
    label: "オンライン申請のアカウント管理",
    value: "company_self_account",
  },
  companySelfAccountEdit: {
    label: "オンライン申請のアカウント管理の編集画面",
    value: "company_self_account_edit",
  },

  // rso
  rso: {
    label: "登録支援機関情報の基本情報",
    value: "rso",
  },
  rsoBranch: {
    label: "登録支援機関情報の事業所一覧",
    value: "rso_branch",
  },
  rsoBranchCreate: {
    label: "登録支援機関情報の事業所登録",
    value: "rso_branch_create",
  },
  rsoBranchEdit: {
    label: "登録支援機関情報の事業所編集",
    value: "rso_branch_edit",
  },
  rsoWorkingSupporter: {
    label: "登録支援機関情報の支援者一覧",
    value: "rso_working_supporter",
  },
  rsoRetiredSupporter: {
    label: "登録支援機関情報の退職者一覧",
    value: "rso_retired_supporter",
  },
  rsoSupporterCreate: {
    label: "登録支援機関情報の支援者登録",
    value: "rso_supporter_create",
  },
  rsoSupporterEdit: {
    label: "登録支援機関情報の支援者編集",
    value: "rso_supporter_edit",
  },
  rsoAccount: {
    label: "登録支援機関情報の電子届出アカウント",
    value: "rso_account",
  },
  rsoAccountEdit: {
    label: "登録支援機関情報の電子届出アカウント編集",
    value: "rso_account_edit",
  },

  // supplier
  supplierList: {
    label: "送り出し機関等の一覧",
    value: "supplier_list",
  },
  supplierCreate: {
    label: "送り出し機関登録",
    value: "supplier_create",
  },
  supplierDetail: {
    label: "送り出し機関詳細",
    value: "supplier_detail",
  },
  supplierEdit: {
    label: "送り出し機関詳細編集",
    value: "supplier_edit",
  },

  // Retirement
  retirement: {
    label: "退職手続き",
    value: "retirement",
  },
  retirementDocument: {
    label: "退職手続き一覧",
    value: "retirement_document",
  },
  retirementFiles: {
    label: "添付書類一覧",
    value: "retirement_files",
  },
  retirementAcceptingWorker: {
    label: "受入れ困難に係る届出",
    value: "retirement_accepting_worker",
  },
  retirementEmploymentContract: {
    label: "特定技能雇用契約に係る届出",
    value: "retirement_employment_contract",
  },

  retirementAcceptingWorkerDetail: {
    label: "受入れ困難に係る届出",
    value: "retirement_accepting_working_detail",
  },
  retirementEmploymentContractDetail: {
    label: "特定技能雇用契約に係る届出",
    value: "retirement_employment_contract_detail",
  },

  // Anytime
  anytime: {
    label: "随時届出",
    value: "anytime",
  },
  anytimeTemplates: {
    label: "随時届出一覧",
    value: "anytime_templates",
  },
  anytimeDocument: {
    label: "過去の随時届出",
    value: "anytime_document",
  },
  anytimeFiles: {
    label: "随時届出の添付ファイル一覧",
    value: "anytime_files",
  },

  anytimeEmploymentContractCreate: {
    label: "雇用契約の変更に係る届出",
    value: "anytime_employment_contract_create",
  },
  anytimeSupportPlanCreate: {
    label: "支援計画変更に係る届出",
    value: "anytime_support_plan_create",
  },
  anytimeSupportContractCreate: {
    label: "支援委託契約に係る届出",
    value: "anytime_support_contract_create",
  },

  anytimeEmploymentContractDetail: {
    label: "雇用契約の変更に係る届出の確認画面",
    value: "anytime_employment_contract_detail",
  },
  anytimeSupportPlanDetail: {
    label: "支援計画変更に係る届出の確認画面",
    value: "anytime_support_plan_detail",
  },
  anytimeSupportContractDetail: {
    label: "支援委託契約に係る届出の確認画面",
    value: "anytime_support_contract_detail",
  },

  anytimeEmploymentContractEdit: {
    label: "雇用契約の変更に係る届出の編集画面",
    value: "anytime_employment_contract_edit",
  },
  anytimeSupportPlanEdit: {
    label: "支援計画変更に係る届出の編集画面",
    value: "anytime_support_plan_edit",
  },
  anytimeSupportContractEdit: {
    label: "支援委託契約に係る届出の編集画面",
    value: "anytime_support_contract_edit",
  },

  // Regular Document
  regularDocument: {
    label: "定期届出",
    value: "regular_document",
  },
  regularDocumentPresent: {
    label: "定期届出（今回）",
    value: "regular_document_present",
  },
  regularDocumentHistory: {
    label: "定期届出（過去）",
    value: "regular_document_history",
  },
  regularDocumentFiling: {
    label: "定期届出の届出書",
    value: "regular_document_filing",
  },
  regularDocumentAppendix: {
    label: "定期届出の添付書類",
    value: "regular_document_appendix",
  },
  regularDocumentOnlineRequest: {
    label: "定期届出のオンライン申請",
    value: "regular_document_online_request",
  },
  companySelfRegularDocumentPresent: {
    label: "定期届出（今回）",
    value: "company_self_regular_document_present",
  },
  companySelfRegularDocumentHistory: {
    label: "定期届出（過去）",
    value: "company_self_regular_document_history",
  },

  // page not found
  pageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "page_not_found",
  },
  externalPageNotFound: {
    label: "「ページが見つかりません」の画面",
    value: "external_page_not_found",
  },
  serverErrorPage: {
    label: "サーバーエラーページ",
    value: "server_error_page",
  },

  // Maintenance
  maintenance: {
    label: "メンテナンス",
    value: "maintenance",
  },

  //
  interview: {
    label: "面談",
    value: "interview",
  },
  lifeSupport: {
    label: "生活支援",
    value: "life_support",
  },
  inquire: {
    label: "",
    value: "inquire",
  },
  procedure: {
    label: "",
    value: "procedure",
  },
  userSettingDetail: {
    label: "ユーザー設定",
    value: "user_setting_detail",
  },
  userSettingEdit: {
    label: "ユーザー設定編集",
    value: "user_setting_edit",
  },
  userSettingChangeEmail: {
    label: "ユーザー設定のメール更新",
    value: "user_setting_change_email",
  },
  booking: {
    label: "",
    value: "booking",
  },
};
